// extracted by mini-css-extract-plugin
export default {"header":"LinkDialog_header__yZT12","body":"LinkDialog_body__zaFGM"};